export const filterBuilder = (category, userType, provider, searchTerm) => (
    game
) => {
    let providerFilter = true;
    if (provider && provider.length) {
        // Can this be split out?
        providerFilter = Array.isArray(provider) ?
            provider.includes(game.game_provider.id) :
            provider === game.game_provider.id;
    }

    const userTypeMatchesGame = () =>
        game.user_types.filter((gameUserType) => {
            return userType.includes(gameUserType.id);
        });

    const userTypeFilter =
        userType && userType.length ? userTypeMatchesGame().length > 0 : true;

    let categoryFilter = true;
    if (category) {
        categoryFilter = category ? category.id === game.game_category.id : true;
    }

    const searchFilter = searchTerm ?
        game.GameName.toLowerCase().includes(searchTerm.toLowerCase()) :
        true;

    return categoryFilter && userTypeFilter && providerFilter && searchFilter;
};

export const gameDemoInIframeMatchProvider = (providers) => {
    const providersMap = providers.reduce((acc, curr) => {
        acc[curr.id] = curr.LaunchGameDemoInIframe || false;
        return acc;
    }, {});
    return (providerId) => {
        return providersMap[providerId];
    };
};